import React from 'react';
import { MainLayout } from '@components';
import ConditionComponents from './Condition';

export default function ConditionPage(props) {
  return (
    <MainLayout footer="main" children={<ConditionComponents {...props} />} />
  );
}
